// context/AuthLayoutContext.js
import React, { createContext, useContext, useMemo, useState } from "react";

const AuthLayoutContext = createContext(null);

export function AuthenticatedLayoutProvider({ children }) {
  const [layoutProps, setLayoutProps] = useState({});
  const [isActive, setIsActive] = useState(false);

  const value = useMemo(
    () => ({
      layoutProps,
      setLayoutProps,
      isActive,
      setIsActive,
    }),
    [layoutProps, isActive]
  );

  return <AuthLayoutContext.Provider value={value}>{children}</AuthLayoutContext.Provider>;
}

export function useAuthLayout() {
  return useContext(AuthLayoutContext);
}